import {
  faArrowLeftLong,
  faArrowRightLong,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { useRef, useState } from "react";
import Slider from "react-slick";
import Container from "../common/Container";

const OurDeveloperHave = (properties) => {
  const { headLine, data } = properties.skilledSection;
  const compatible = properties.compatible;
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: compatible.length <= 2 ? 2 : 3,
    slidesToScroll: 1,
    touchMove: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const TechCombination = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const jumpToSlide = (slide) => {
    setActiveSlide(slide);
    TechCombination.current.slickGoTo(slide);
  };
  return (
    <Container large className="bg-primary-black">
      <div className="py-32 md:py-20 lg:py-40">
        <h2 className="text-4xl leading-snug md:text-3xl lg:text-6xl lg:leading-tight font-medium text-white mb-0 pb-11 md:pb-0">
          <span>{headLine}</span>
        </h2>
        <div
          className={
            "pb-14 md:py-8 lg:py-20 flex flex-wrap flex-col md:flex-row"
          }
        >
          {data && data.length > 0
            ? data.map((value) => (
                <div key={value.title} className="md:w-1/2 md:px-3 lg:px-0">
                  <p className="border-l-2 border-solid pl-4 my-6 lg:mr-16 md:h-16 text-base text-white text-justify">
                    <span
                      dangerouslySetInnerHTML={{ __html: value.title }}
                    ></span>
                  </p>
                </div>
              ))
            : undefined}
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div
            className={
              compatible.length <= 2 ? "md:w-12/4" : "w-full md:w-10/12"
            }
          >
            <Slider
              {...settings}
              ref={(slider) => (TechCombination.current = slider)}
            >
              {compatible && compatible.length > 0
                ? compatible.map((value, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div key={index} className="my-0 mx-4">
                      <div className="mb-10 py-12 px-8 md:py-8 md:px-4 lg:py-12 lg:px-8 lg:mb-0 rounded-lg bg-[#2d2727] flex justify-between items-center mr-4 flex-col gap-4">
                        <div className="flex flex-row">
                          {value.tech.map((itm) => (
                            <div
                              key={itm.iconPath}
                              className="mx-4 md:h-9 lg:h-fit"
                              title={value.tech[1].iconAlt}
                            >
                              <Image
                                alt={itm.iconAlt}
                                height={45}
                                objectFit="contain"
                                quality={100}
                                src={itm.iconPath}
                                width={45}
                              />
                            </div>
                          ))}
                        </div>
                        <p className="text-white text-base font-normal mb-0">
                          <span>{value.tech[1].iconAlt}</span>
                        </p>
                      </div>
                    </div>
                  ))
                : undefined}
            </Slider>
          </div>
          <div
            className={
              compatible.length <= 3
                ? "hidden"
                : `md:w-12/2 flex justify-center lg:justify-end`
            }
          >
            <div
              className={`text-white border border-solid border-white rounded-full flex justify-center items-center cursor-pointer w-12 h-12 md:h-10 md:w-10 lg:h-12 lg:w-12 m-0 mr-4 md:px-2 ${
                Number(activeSlide) === 0 ? "opacity-50 text-3xl" : ""
              }`}
              role="presentation"
              onClick={() => {
                Number(activeSlide) === 0
                  ? undefined
                  : jumpToSlide(
                      activeSlide === 0
                        ? compatible.length - 1
                        : activeSlide - 1
                    );
              }}
            >
              <FontAwesomeIcon
                height={"30px"}
                icon={faArrowLeftLong}
                width={"25px"}
              />
            </div>
            <div
              className={`text-white border border-solid border-white rounded-full flex justify-center items-center cursor-pointer w-12 h-12 md:h-10 md:w-10 lg:h-12 lg:w-12 m-0 text-3xl md:px-2 lg:mx-0 ${
                compatible.length - 1 === activeSlide * 1 ? "opacity-50" : ""
              }`}
              id="arrow"
              role="presentation"
              onClick={() => {
                compatible.length - 1 === activeSlide * 1
                  ? undefined
                  : jumpToSlide(
                      activeSlide === compatible.length - 1
                        ? 0
                        : activeSlide + 1
                    );
              }}
            >
              <FontAwesomeIcon
                height="30px"
                icon={faArrowRightLong}
                width="25px"
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OurDeveloperHave;
